import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "password-input-container" }
const _hoisted_2 = { style: {"left":"-10px"} }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
      type: "password",
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowRule = true)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowRule = false))
    }, null, 8, ["modelValue"]),
    _createVNode("ul", {
      class: "limit",
      style: {display:_ctx.isShowRule?'block':'none'}
    }, [
      _createVNode("li", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextPasswordFlow) + ":", 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rules, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: item.vaild ? "success":  "default",
          key: item
        }, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(item.content), 1)
        ], 2))
      }), 128))
    ], 4)
  ]))
}